<div *ngIf="sessionGuardWaiting$ | async" class="session-restoration-loading d-flex align-items-center justify-content-center"
     role="status" aria-live="polite" aria-label="Restoring your session" aria-busy="true">
    <loading-card [itemsLoading]="true"></loading-card>
</div>
<ng-container *ngIf="this.isLocalizationReady">
	<toaster-container [toasterconfig]="toasterConfig"></toaster-container>
	<router-outlet></router-outlet>
</ng-container>
